import React from "react";
import { Col, Row, Spinner } from "reactstrap";
import { useSelector } from "react-redux";
import useSWR from "swr";
import NumberFormat from "react-number-format";
import CardSummary from "../../UI/cards/CardSummary";
import { fetchCondominium } from "../../../helpers/api/condominium";
import { fetchAllPages } from "../../../helpers/api/pagination";

// No existe un endpoint de agregados, así que traemos todos los condominios
// (de a 100 por página, el tope de la API) y sumamos sus propiedades en el
// cliente. meta.total da el conteo real de condominios.

const CondominiumStats = () => {
  const { token } = useSelector((state) => state.auth.user);

  const { data, error } = useSWR(["condominium-stats", token], () =>
    fetchAllPages((page, pageSize) => fetchCondominium(page, pageSize, { token }))
  );

  const loading = !data && !error;

  const totalCondominiums = data?.meta?.total ?? 0;
  const totalProperties = (data?.data || []).reduce(
    (acc, condominium) => acc + (Number(condominium.properties_count) || 0),
    0
  );

  const renderValue = (value) =>
    loading ? (
      <Spinner size="sm" />
    ) : (
      <NumberFormat value={value} displayType="text" thousandSeparator />
    );

  return (
    <Row noGutters className="mb-3">
      <Col md={6} className="pr-md-2 mb-3 mb-md-0">
        <CardSummary title="Condominios registrados" color="info">
          {renderValue(totalCondominiums)}
        </CardSummary>
      </Col>
      <Col md={6} className="pl-md-2">
        <CardSummary title="Propiedades totales" color="success">
          {renderValue(totalProperties)}
        </CardSummary>
      </Col>
    </Row>
  );
};

export default CondominiumStats;
